import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@xing-com/button';
import {
  PAGES_NEWS_PATH,
  PAGES_PATH,
  URL_SOCIAL_BAR,
} from '@xing-com/crate-entity-pages-common';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { SocialBar } from '@xing-com/crate-social-bar';
import { IconMore } from '@xing-com/icons';
import { usePopOver } from '@xing-com/pop-over';

import { useAbsoluteUrl } from '../../../hooks/use-absolute-url/use-absolute-url';
import { useNewsContext } from '../../../hooks/use-news-context/use-news-context';
import { useNewsItemContext } from '../../../hooks/use-news-item-context/use-news-item-context';
import { NewsItemMenu } from '../news-item-menu/news-item-menu';

import * as Styled from './news-item-social.style';

export const NewsItemSocial: FC<{ position?: string }> = ({
  position = '',
}) => {
  const { formatMessage } = useIntl();
  const { post } = useNewsItemContext();
  const { isDetailPage } = useNewsContext();
  const { pageContext, isSubpage } = usePageContext();
  const activityId = post?.globalId?.split(':').pop();

  // include back_to parameter to allow startpage to link back to current page
  const detailUrl = `/discover/detail-activities/${activityId}?back_to=${encodeURIComponent(
    isDetailPage
      ? PAGES_NEWS_PATH(pageContext.pageSlug)
      : PAGES_PATH(pageContext.pageSlug)
  )}`;
  const shareUrl = useAbsoluteUrl(detailUrl);

  const popOver = usePopOver();
  const flyOut = (
    <Styled.Actions>
      <Button
        data-testid="flyout-anchor"
        size={'medium'}
        icon={IconMore}
        onClick={popOver.handleShow}
        innerRef={popOver.triggerRef}
        aria-label={formatMessage({
          id: 'ARTICLES_ARTICLE_VIEWER_ARIA_LABEL_BUTTON_MORE',
        })}
        aria-expanded={popOver.show}
      />
    </Styled.Actions>
  );

  const handleCommentClick = (): void => window.location.assign(detailUrl);

  return (
    <Styled.Wrapper>
      <SocialBar
        backendTrackingMetaData={{
          position,
          page: isSubpage
            ? 'entity_pages/subpage/news'
            : 'entity_pages/overview',
        }}
        urn={post.globalId!}
        url={shareUrl}
        onCommentClick={handleCommentClick}
        hasShare={post.metadata?.isRecommendable}
        hasReaction={post.metadata?.isLikeable}
        hasComment={post.metadata?.isCommentable}
        shareZenViewTo={URL_SOCIAL_BAR}
        propChannel="wbm/EntityPages"
        rightBar={flyOut}
      />

      {post.globalId ? (
        <NewsItemMenu authorUrn={post.globalId} popOver={popOver} />
      ) : null}
    </Styled.Wrapper>
  );
};
